import { gql } from "@apollo/client";

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: ID!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      id
      categoryName
      accountCategory
      accountCategorySearchTerm
      accountSystem
      accountCategoryId
    }
  }
`;

export const GET_COMPANY_CATEGORIES = gql`
  query MyCategories {
    myCategories {
      id
      categoryName
      accountCategoryId
      accountCategory
      accountSystem
    }
  }
`;
